
export const SPEEDS = [
  // { value: 1000 * 60 * 1, label: '1 min/s' },
  // { value: 1000 * 60 * 5, label: '5 min/s' },
  // { value: 1000 * 60 * 10, label: '10 min/s' },
  { value: 1000 * 60 * 15, label: '15 min/s' },
  { value: 1000 * 60 * 30, label: '30 min/s' },
  { value: 1000 * 60 * 60, label: '1 hr/s' },
  { value: 1000 * 60 * 60 * 3, label: '3 hr/s' },
  { value: 1000 * 60 * 60 * 6, label: '6 hr/s' },
  // { value: 1000 * 60 * 60 * 12, label: '12 hr/s' },
  // { value: 1000 * 60 * 60 * 24, label: '24 hr/s' },
  // { value: 1000 * 60 * 60 * 24 * 7, label: '7 day/s' },
]



export const NYC_BOUNDS = {
  south: 40.477399,
  west: -74.25909,
  north: 40.917577,
  east: -73.700272,
}
// const BASE_URL = import.meta.env.VITE_OGC_FEATURES_BASE || 'https://gis.floodnet.nyc/features';
// export const BASE_URL = import.meta.env.VITE_OGC_FEATURES_BASE || 'https://gis.dev.floodlabs.nyc/features';
// const BASE_URL = import.meta.env.VITE_OGC_FEATURES_BASE || 'https://features.dev.floodlabs.nyc/features';


const DEV_URL = 'https://gis.dev.floodlabs.nyc/features';
const LIVE_URL = 'https://gis.floodnet.nyc/features';
// const BASE_URL_ = DEV_URL;
const BASE_URL_ = LIVE_URL;
export const BASE_URL = import.meta.env.VITE_OGC_URL || BASE_URL_;

export const OGC_FUNCTIONS = {
  // EVENT_DEPTH_DATA: 'postgisftw.event_depth_data',
  EVENT_DEPTH_DATA: 'postgisftw.tentative_event_depth_data',
  MAX_PRECIP_DATA: 'postgisftw.max_precip_data',
}

export const OGC_COLLECTIONS = {
  SENSOR_LOCATIONS: 'ogc.sensor_locations',
  // SENSOR_LOCATIONS: 'ogc.sensor_locations_dev',
  PAST_FLOOD_EVENTS: 'ogc.past_flood_events',
}


// TODO: these should navigate / update URL params
export const LIVE_PRESET_RANGES: { label: string; fromTime: string; toTime: string }[] = [
  { label: 'Last 1 hour', fromTime: 'now-1h', toTime: 'now' },
  { label: 'Last 2 hours', fromTime: 'now-2h', toTime: 'now' },
  { label: 'Last 3 hours', fromTime: 'now-3h', toTime: 'now' },
  { label: 'Last 6 hours', fromTime: 'now-6h', toTime: 'now' },
  { label: 'Last 12 hours', fromTime: 'now-12h', toTime: 'now' },
  { label: 'Last 24 hours', fromTime: 'now-24h', toTime: 'now' },
  { label: 'Last 2 days', fromTime: 'now-2d', toTime: 'now' },
  { label: 'Last 7 days', fromTime: 'now-7d', toTime: 'now' },
  { label: 'Last 30 days', fromTime: 'now-30d', toTime: 'now' },
  { label: 'Last 180 days', fromTime: 'now-180d', toTime: 'now' },
  { label: 'Last 1 year', fromTime: 'now-1y', toTime: 'now' },
  { label: 'Last 2 years', fromTime: 'now-2y', toTime: 'now' },
  { label: 'Last 5 years', fromTime: 'now-5y', toTime: 'now' },
];
// export const PRESET_RANGES: { label: string; fromTime: string; toTime: string }[] = [
//   { label: "Oct 30-31, 2025", fromTime: '2025-10-30T14:00:00Z', toTime: '2025-10-31T12:00:00Z' },
//   { label: "Coastal flooding - Sep 15-25 2024", fromTime: '2024-09-15T00:00:00Z', toTime: '2024-09-25T23:59:59Z' },
//   { label: "Sep 29-30, 2023", fromTime: '2023-09-29T00:00:00Z', toTime: '2023-09-30T04:00:00Z' },
//   { label: "Hurricane Ida", fromTime: '2021-09-01T18:00:00Z', toTime: '2021-09-02T10:00:00Z' },
//   { label: "Hurricane Henri", fromTime: '2021-08-21T20:00:00Z', toTime: '2021-08-22T10:00:00Z' },
// ];
export const PRESET_RANGES: { label: string; fromTime: string; toTime: string }[] = [
  // America/New_York (EDT/EST offsets applied)
  { label: "Oct 30-31, 2025", fromTime: '2025-10-30T10:00:00-04:00', toTime: '2025-10-31T08:00:00-04:00' },
  { label: "Coastal flooding - Sep 15-25 2024", fromTime: '2024-09-14T20:00:00-04:00', toTime: '2024-09-25T19:59:59-04:00' },
  { label: "Sep 29-30, 2023", fromTime: '2023-09-28T20:00:00-04:00', toTime: '2023-09-30T00:00:00-04:00' },
  { label: "Hurricane Ida", fromTime: '2021-09-01T14:00:00-04:00', toTime: '2021-09-02T06:00:00-04:00' },
  { label: "Hurricane Henri", fromTime: '2021-08-21T16:00:00-04:00', toTime: '2021-08-22T06:00:00-04:00' },
];


export const WEATHER_CONDITIONS = [
  { key: 'sun', label: 'Sun' },
  { key: 'rain', label: 'Rain' },
  { key: 'light-rain', label: 'Light Rain' },
  { key: 'heavy-rain', label: 'Heavy Rain' },
  { key: 'downpour', label: 'Downpour' },
  { key: 'sunny-rain', label: 'Sunny Rain' },
];